import { KEYS } from '../constants.js';

function useHandleKeyDown({ tabsRef, focusedTabIndex, setFocusedTabIndex, }) {
    const getTabIndexFromPreviousTab = () => {
        const tabsRefArray = tabsRef.current;
        const lastTabIndex = tabsRefArray.length - 1;
        const isFirstTab = focusedTabIndex === 0;
        const prevTabIndex = isFirstTab ? lastTabIndex : focusedTabIndex - 1;
        return prevTabIndex;
    };
    const handleKeyDown = (event) => {
        const tabsRefArray = tabsRef.current;
        const { keyCode } = event;
        const lastTabIndex = tabsRefArray.length - 1;
        if (!tabsRefArray.length)
            return;
        switch (keyCode) {
            case KEYS.space:
            case KEYS.enter: {
                event.preventDefault();
                const tabButton = event.target;
                tabButton.click();
                break;
            }
            case KEYS.left: {
                const prevTabIndex = getTabIndexFromPreviousTab();
                setFocusedTabIndex(prevTabIndex);
                tabsRefArray[prevTabIndex].focus();
                break;
            }
            case KEYS.right: {
                const isLastTab = focusedTabIndex === lastTabIndex;
                const nextTabIndex = isLastTab ? 0 : focusedTabIndex + 1;
                setFocusedTabIndex(nextTabIndex);
                tabsRefArray[nextTabIndex].focus();
                break;
            }
            case KEYS.home: {
                event.preventDefault();
                setFocusedTabIndex(0);
                tabsRefArray[0].focus();
                break;
            }
            case KEYS.end: {
                event.preventDefault();
                setFocusedTabIndex(lastTabIndex);
                tabsRefArray[lastTabIndex].focus();
                break;
            }
        }
    };
    return [handleKeyDown];
}

export { useHandleKeyDown };
